export const BlindsDown = () => (
  <svg
    width="59"
    height="58"
    viewBox="0 0 59 58"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-25%"
        y="-14.4%"
        width="150%"
        height="151.1%"
        filterUnits="objectBoundingBox"
        id="srjhrchoza"
      >
        <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <rect id="qlmd7txp4b" x="2.408" y="2" width="46" height="45" rx="16" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(4)">
        <use fill="#000" filter="url(#srjhrchoza)" xlinkHref="#qlmd7txp4b" />
        <use fill="#FFF" xlinkHref="#qlmd7txp4b" />
      </g>
      <path
        d="M30 26.864 42.5 19v7.11L30 34h.028L17.5 26.11V19l12.528 7.864"
        fill="#2396FD"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
